import React, { memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useFeatures } from '../../../../hooks/useFeatures';

// Memoized single feature checkbox to prevent re-rendering all checkboxes
const FeatureCheckbox = memo(({ 
  feature, 
  isSelected, 
  onChange 
}: { 
  feature: any, 
  isSelected: boolean, 
  onChange: (id: string, checked: boolean) => void 
}) => {
  return (
    <div className="flex items-center">
      <input
        type="checkbox"
        id={`feature-${feature.id}`}
        checked={isSelected}
        onChange={(e) => onChange(feature.id, e.target.checked)}
        className="h-4 w-4 text-primary border-gray-300 rounded focus:ring-primary"
      />
      <label htmlFor={`feature-${feature.id}`} className="ml-2 text-sm text-gray-700">
        {feature.name}
      </label>
    </div>
  );
});

const FeaturesSection = () => {
  const formContext = useFormContext();
  const {
    features,
    selectedFeatures,
    setSelectedFeatures
  } = useFeatures();

  // Group features by category
  const categories = [...new Set(features.map(f => f.category || 'Altro'))];

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <div className="flex justify-between items-center mb-4 pb-2 border-b">
        <h3 className="text-lg font-semibold">Dotazioni</h3>
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-3">
          Seleziona le dotazioni presenti nell'immobile
        </label>
        
        {categories.map(category => {
          const categoryFeatures = features.filter(f => (f.category || 'Altro') === category);
          
          return (
            <div key={category} className="mb-6">
              <h4 className="font-medium text-gray-700 mb-2">{category}</h4>
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                {categoryFeatures.map(feature => (
                  <FeatureCheckbox
                    key={feature.id}
                    feature={feature}
                    isSelected={selectedFeatures.includes(feature.id)}
                    onChange={(id, checked) => {
                      if (checked) {
                        setSelectedFeatures([...selectedFeatures, id]);
                      } else {
                        setSelectedFeatures(selectedFeatures.filter(featureId => featureId !== id));
                      }
                    }}
                  />
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default memo(FeaturesSection);